<i18n src="@/locales/modules/PostTranslate.json"></i18n>

<template>
	<div id="posts-management" class="data-list-container">
		<div class="dropdown-button-container flex justify-end md:hidden lg:hidden xl:hidden">
			<vs-dropdown vs-trigger-click>
				<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
				<vs-dropdown-menu>
					<vs-dropdown-item>
						<vs-button class="w-48 font-bold" type="filled" @click="handleClickCreatePost">{{ $t("CreatePost") }}</vs-button>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

		<div class="flex flex-grow justify-end">
			<div class="md:flex lg:flex xl:flex hidden">
				<vs-button class="w-30 font-bold" type="filled" @click="handleClickCreatePost">{{ $t("CreatePost") }}</vs-button>
			</div>
		</div>

		<div class="list-posts mt-6 grid grid-cols-3 gap-4" ref="listPostRef">
			<div class="col-span-3 md:col-span-2">
				<post-item
					class="mb-6 last:mb-0 "
					v-for="post in listPosts"
					:value="post"
					:key="post.id"
					:maxContentHeight="110"
					@onClickEdit="handleClickEditPost"
					@onSentComment="handleOnSentComment"
					@onClickDelete="handleClickDeletePost"
				/>
			</div>
			<div class="order-first col-span-3 md:col-span-1 md:order-last">
				<vx-card class="mb-6" v-if="featurePosts && featurePosts.length > 0">
					<div slot="title" class="w-full">
						<h5 class="uppercase text-black font-bold">{{ $t("HotNews") }}</h5>
						<vs-divider class="mb-0" />
					</div>
					<post-item
						class="mb-6 last:mb-0 "
						v-for="post in featurePosts"
						:value="post"
						:key="post.id"
						:maxContentHeight="110"
						@onClickEdit="handleClickEditPost"
						@onSentComment="handleOnSentComment"
						@onClickDelete="handleClickDeletePost"
					/>
				</vx-card>
				<vx-card class="mb-6" v-if="appellations && appellations.length > 0">
					<div slot="title" class="w-full">
						<h5 class="uppercase text-black font-bold">{{ $t("Felicitation") }}</h5>
						<vs-divider class="mb-0" />
					</div>
					<div>
						<div v-for="(val, idx) in appellations" :key="val.employee.id" class="text-center">
							<vs-avatar size="64px" :src="val.employee.avatar" />
							<h5 class="font-bold capitalize text-primary">{{ val.employee.name }}</h5>
							<p class="text-black text-base">{{ val.appellation }}</p>
							<vs-divider v-if="idx !== 1" />
						</div>
					</div>
				</vx-card>
				<vx-card class="mb-6" v-if="employees && employees.length > 0">
					<div slot="title" class="w-full">
						<h5 class="uppercase text-black font-bold">{{ $t("Members") }}</h5>
						<vs-divider class="mb-0" />
					</div>
					<div class="grid grid-cols-4 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5  sm:gap-3 md:gap-4 lg:gap-5">
						<span v-for="employee in employees" :key="employee.id">
							<vx-tooltip class="inline-block" :text="employee.name" position="top">
								<vs-avatar :src="employee.avatar" size="50px" />
							</vx-tooltip>
						</span>
					</div>
				</vx-card>
				<iframe src="https://covid19.vnanet.vn/home/indexwiget" frameborder="0" width="100%" style="min-height: 430px;"> </iframe>
			</div>
		</div>

		<div id="list-posts-loading"></div>
		<form-post-dialog v-if="isShowFormPostDialog" v-model="activePostData" :isDialogActive="isShowFormPostDialog" @closeDialog="toggleFormPostDialog" @onSubmit="handleCreateOrUpdatePost" />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import modulePost from "@/store/post/modulePost";
import employeeInsideGql from "@/http/requests/inside/employee_gql";

import PostItem from "./PostItem";
import FormPostDialog from "./FormPostDialog";

const initActivePostData = {
	id: null,
	tags: [],
	files: [],
	content: "",
	categoryId: null
};

export default {
	components: { PostItem, FormPostDialog },
	data() {
		return {
			activePostData: null,

			currentPage: 1,
			isFetching: false,
			isShowFormPostDialog: false,
			employees: []
		};
	},
	computed: {
		...mapGetters({
			getParsedPosts: "postsManagement/getParsedPosts",
			getParsedFeaturePosts: "postsManagement/getParsedFeaturePosts"
		}),
		listPosts() {
			return this.getParsedPosts || [];
		},
		isHasMorePages() {
			return this.$store.state.postsManagement.isHasMorePages || false;
		},

		appellations() {
			return this.$store.state.postsManagement.appellations;
		},
		featurePosts() {
			return this.getParsedFeaturePosts || [];
		}
	},
	methods: {
		getPosts(isLoadMore = false) {
			if (!isLoadMore || (isLoadMore && this.isHasMorePages)) {
				clearTimeout(this.getPostsTimer);
				this.getPostsTimer = setTimeout(async () => {
					try {
						this.showLoading();
						this.isFetching = true;
						if (isLoadMore) {
							this.currentPage += 1;
						}

						const queryOptions = {
							page: this.currentPage,
							limit: this.$store.state.postsManagement.limitPerPage
						};
						// Fetch postList
						await this.$store.dispatch("postsManagement/getPosts", queryOptions);
					} catch (error) {
						this.$helper.notifyError({ context: this, error });
					} finally {
						this.isFetching = false;
						this.$nextTick(() => this.hideLoading());
					}
				}, 200);
			}
		},
		toggleFormPostDialog(val = false) {
			this.isShowFormPostDialog = val;
		},
		scroll() {
			window.onscroll = () => {
				if (this.$refs.listPostRef) {
					const appHeight = document.querySelector("#app").offsetHeight;
					const loadMorePostion = appHeight - this.$refs.listPostRef.offsetHeight;
					const bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= appHeight - loadMorePostion;
					if (bottomOfWindow && this.isHasMorePages && !this.isFetching) {
						this.getPosts(true);
					}
				}
			};
		},
		showLoading() {
			this.$vs.loading({
				container: "#list-posts-loading",
				scale: 0.6
			});
		},
		hideLoading() {
			this.$vs.loading.close("#list-posts-loading > .con-vs-loading");
		},
		handleClickCreatePost() {
			this.activePostData = { ...initActivePostData };
			this.toggleFormPostDialog(true);
		},
		handleClickEditPost(postData) {
			this.activePostData = Object.assign(
				{},
				{
					...postData,
					tags: postData.people || [],
					categoryId: postData.category && postData.category.id
				}
			);
			this.toggleFormPostDialog(true);
		},
		async handleClickDeletePost(postData) {
			try {
				this.$vs.loading();
				this.$store.dispatch("postsManagement/deletePost", postData.id);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeletePostSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleCreateOrUpdatePost() {
			try {
				this.$vs.loading();
				const isEdit = !!this.activePostData.id;
				const payload = {
					people: this.activePostData.tags,
					content: this.activePostData.content,
					category: this.activePostData.categoryId,
					files: this.activePostData.files.map(file => file.id)
				};

				if (isEdit) {
					payload.id = this.activePostData.id;
					await this.$store.dispatch("postsManagement/updatePost", payload);
				} else {
					await this.$store.dispatch("postsManagement/addPost", payload);
				}
				this.toggleFormPostDialog();
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t(`${isEdit ? "UpdatePostSuccessful" : "CreatePostSuccessful"}`)
					}
				});
				this.$emit("closeDialog");
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleOnSentComment(commentData) {
			const postId = commentData.data && commentData.data[0] && commentData.data[0].post_id;
			this.$store.commit("postsManagement/SEND_COMMENT", postId);
		},
		async getEmployees() {
			const res = await employeeInsideGql.fetchEmployeesForPost();
			if (res && res.employees) {
				this.employees = res.employees;
			}
		}
	},
	async created() {
		this.$store.registerModule("postsManagement", modulePost);
		this.getPosts();
		this.$store.dispatch("postsManagement/getAppellations");
		await this.$store.dispatch("postsManagement/getFeaturePosts", { is_feature: true });
		this.getEmployees();
	},
	mounted() {
		this.scroll();
	},
	beforeDestroy() {
		this.$store.commit("postsManagement/RESET_STATE");
		this.$store.unregisterModule("postsManagement");
	}
};
</script>

<style lang="scss" scoped>
#posts-management {
	#list-posts-loading ::v-deep .con-vs-loading {
		position: relative;
	}
	.list-posts {
		.vx-card {
			box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.13);
		}
		.badge-online {
			position: relative;
			&:after {
				content: "";
				position: absolute;
				left: 77.08%;
				right: 2.08%;
				top: 77.08%;
				bottom: 2.08%;
				border-radius: 50%;
				background: #219653;
				border: 1px solid #ffffff;
				box-sizing: border-box;
			}
		}
	}
}
</style>
